export type BuildupPhase = 'p1' | 'p2'

export interface ResolveInitialPhaseInput {
  stored: BuildupPhase | string | null
  audioResponse1: string | null | undefined
  audioResponse2?: string | null
  isDesignatedReview?: boolean
}

const VALID: ReadonlySet<BuildupPhase> = new Set(['p1', 'p2'])
const LEGACY_STEP_4_PHASES = new Set(['p2a', 'p2b'])

function isValid(v: unknown): v is BuildupPhase {
  return typeof v === 'string' && VALID.has(v as BuildupPhase)
}

export function resolveInitialPhase({
  stored,
  audioResponse1,
  audioResponse2,
  isDesignatedReview,
}: ResolveInitialPhaseInput): BuildupPhase {
  if (isDesignatedReview) return 'p2'
  if (typeof stored === 'string' && LEGACY_STEP_4_PHASES.has(stored)) return 'p2'
  if (isValid(stored)) return stored
  if (audioResponse2 && audioResponse2.trim().length > 0) return 'p2'
  if (audioResponse1 && audioResponse1.trim().length > 0) return 'p2'
  return 'p1'
}
